import axios from 'axios';
import * as authActions from '../auth/actions';
import {
  refreshAccessToken,
  isAccessTokenExpired
} from '../utils/auth0/access-token';
import { displayLogoutDialog } from '../auth/actions';
import * as endpoints from '../api/const';

/** Axios Interceptor class for handling global error status like 404,500 and Network errors as well
 * */
export const FormatErrorMsg = error => {
  if (!Object.keys(error).length) return null;
  // console.log({ error });

  return (
    (error.response && error.response.statusText) ||
    error.message ||
    error.stack ||
    JSON.stringify(error)
  );
};

const errorHandling = (error, store) => {
  // TODO - expand this method to handle different error code
  if (error.response) {
    switch (error.response.status) {
      case 401:
        store.dispatch(authActions.logout());
        break;
      default:
    }
  }

  store.dispatch({
    type: 'SERVER_ERROR',
    status: error.status,
    msg: FormatErrorMsg(error)
  });
};

async function accessTokenCheck(store, config) {
  // List of URLs to exclude from token check
  const excludedUrls = [endpoints.REQUEST_DEMO];
  // Check if the request URL is in the excluded list
  const isExcludedUrl = excludedUrls.some(url => config.url.includes(url));
  // If it's an excluded URL, skip the token check
  if (isExcludedUrl) {
    return; // Skip further token checks
  }

  if (isAccessTokenExpired()) {
    displayLogoutDialog()(store.dispatch);
    return;
  }

  await refreshAccessToken({ ignoreCache: true });
}

class ApiInterceptor {
  // Static method called when initalizing the app via the index.js

  static configAPICallsWithErrorHandle = store => {
    // Add a request interceptor
    axios.interceptors.request.use(
      async config => {
        await accessTokenCheck(store, config);
        return config;
      },
      async error => {
        await accessTokenCheck(store, error.config);
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      response =>
        // Do something with response data
        // console.log({ response });
        response,
      error => {
        // Do something with response error

        errorHandling(error, store);

        return Promise.reject(error);
      }
    );
  };
}

export default ApiInterceptor;



// WEBPACK FOOTER //
// ./src/interceptors/ApiInterceptor.js